<template>
  <span
    class="error-icon"
  >
    <icon-exclamation
      class="error-icon__char"
    />
  </span>
</template>

<script>
import IconExclamation from '@/mikan/_shared/components/atoms/icons/IconExclamation.vue';

export default {
  components: {
    IconExclamation,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.error-icon {
  display: inline-flex;
  width: px-to-em(24px);
  height: px-to-em(24px);
  align-items: center;
  justify-content: center;
  background-color: $color-white;
  border-radius: 50%;

  &__char {
    color: $color-strawberry;
    font-size: px-to-em(23px);
  }
}
</style>
